import * as api from '../api';
import { PURGE } from 'redux-persist';

const GET_BATTERY_TYPES = 'vehicles/GET_BATTERY_TYPES';

const initialState = [];

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_BATTERY_TYPES:
      return action.data;
    case PURGE:
      return [];
    default:
      return state;
  }
}

export const getBatteryTypes = () => {
  return dispatch => {
    return api.getBatteryTypes().then(types => {
      dispatch({ type: GET_BATTERY_TYPES, data: types });
    });
  };
};
